import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PushNotificationsActions = createActionGroup({
  source: 'PushNotifications',
  events: {
    'Upload Csv': props<{ fileName: string; fileData: string }>(),
    'Upload Csv Success': props<{ data: any; fileName: string }>(),
    'Upload Csv Failure': props<{ error: any }>(),

    'Load Latest Upload': emptyProps(),
    'Load Latest Upload Success': props<{ data: any }>(),
    'Load Latest Upload Failure': props<{ error: any }>(),

    'Delete Upload': emptyProps(),
    'Delete Upload Success': emptyProps(),
    'Delete Upload Failure': props<{ error: any }>(),

    'Reset State': emptyProps(),
  },
});